import { inject } from '@angular/core';
import { from, Observable, switchMap } from 'rxjs';
import { AuthService } from '@auth/infra';

export class ChangePasswordCommandHandler {
  private readonly authService: AuthService = inject(AuthService);

  changePassword(currentPassword: string, newPassword: string): Observable<void> {
    return this.authService
      .reauthenticate(currentPassword)
      .pipe(switchMap(() => from(this.authService.updateUserPassword(newPassword))));
  }
}
